import request from 'request-promise';

import thunker from './thunker';
import { API_URL } from './urls';


export const SUBMIT_NAME = "SUBMIT_NAME";
export const SUBMIT_NAME_FAILURE = "SUBMIT_NAME_FAILURE";
export const SUBMIT_NAME_SUCCESS = "SUBMIT_NAME_SUCCESS";
export const SUBMIT_ZIP = "SUBMIT_ZIP";
export const SUBMIT_ZIP_FAILURE = "SUBMIT_ZIP_FAILURE";
export const SUBMIT_ZIP_SUCCESS = "SUBMIT_ZIP_SUCCESS";
export const SUBMIT_PHONE = "SUBMIT_PHONE";
export const SUBMIT_PHONE_FAILURE = "SUBMIT_PHONE_FAILURE";
export const SUBMIT_PHONE_SUCCESS = "SUBMIT_PHONE_SUCCESS";
export const CONFIRM_CODE = "CONFIRM_CODE";
export const CONFIRM_CODE_FAILURE = "CONFIRM_CODE_FAILURE"
export const CONFIRM_CODE_SUCCESS = "CONFIRM_CODE_SUCCESS";
export const UPDATE_STEP_FAILURE = "UPDATE_STEP_FAILURE";
export const UPDATE_STEP_SUCCESS = "UPDATE_STEP_SUCCESS"; 

export const submitName = (firstname, lastname) => {
  return thunker({
    types: [
      SUBMIT_NAME,
      SUBMIT_NAME_SUCCESS,
      SUBMIT_NAME_FAILURE,
    ],
    promise: verifyName(firstname, lastname),
    data: { firstname, lastname },
  });
};

function verifyName(first, last) {
  return new Promise((resolve, reject) => {
    if (first && last) {
      resolve(true);
    } else {
      reject(new Error("Please include both your first and last name."));
    }
  });
};

export const submitZip = (zipcode) => {
  return thunker({
    types: [
      SUBMIT_ZIP,
      SUBMIT_ZIP_SUCCESS,
      SUBMIT_ZIP_FAILURE,
    ],
    promise: verifyZipcode(zipcode),
    data: { zipcode },
  });
}

function verifyZipcode(zip) {
  return new Promise((resolve, reject) => {
    if (zip && zip.length === 5) {
      resolve(true);
    } else {
      reject(new Error("A 5 digit zipcode is required to help identify localized actions."));
    }
  });
}

export const submitPhone = (tempUser) => {
  const { phone } = tempUser;

  return thunker({
    types: [
      SUBMIT_PHONE,
      SUBMIT_PHONE_SUCCESS,
      SUBMIT_PHONE_FAILURE,
    ],
    promise: createTempUser(tempUser),
    data: { phone },
  });
}

function createTempUser(tempUser) {
  const {
    firstname,
    lastname,
    zipcode,
    phone,
  } = tempUser;

  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      uri: `${API_URL}/addTempUser`,
      body: {
        firstname,
        lastname,
        zipcode,
        phone,
      },
      json: true,
    };

    request(options)
      .then((res) => {
         resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const confirmCode = (tempUser) => {
  const { phone, code } = tempUser;

  return thunker({
    types: [
      CONFIRM_CODE,
      CONFIRM_CODE_SUCCESS,
      CONFIRM_CODE_FAILURE,
    ],
    promise: confirm(code, phone),
  });
}

function confirm(code, phone) {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      uri: `${API_URL}/confirmTempCode`,
      body: {
        code,
        phone,
      },
      json: true,
    };

    request(options)
      .then((res) => {
         resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const updateStep = (step) => (
  (dispatch, getState) => {
    const { firstname, lastname, zip, phone } = getState().signup;

    let qualified = false;
    switch(step) {
      case null:
        qualified = true;
        break;

      case "ENTER_ZIPCODE":
        if (firstname && lastname) {
          qualified = true;
        }
        break;

      case "ENTER_PHONE":
        if (firstname && lastname && zip) {
          qualified = true;
        }
        break;

      case "CONFIRM_CODE":
        if (firstname && lastname && zip && phone) {
          qualified = true;
        }
        break;

      default:
        qualified = false;
        break;
    }

    if (qualified) {
      return dispatch({
        type: UPDATE_STEP_SUCCESS,
        data: {
          step,
        },
      });
    }

    return dispatch({
      type: UPDATE_STEP_FAILURE,
      error: "Please complete the current step first.",
    });
  }
);



// WEBPACK FOOTER //
// ./src/actions/signupActions.js